import { and, isControl, optionIs, rankWith } from "@jsonforms/core";
export default rankWith(30, and(isControl, optionIs("EventUnitAddressFill", true)));
